export const isEdgeBrowser = window.navigator.userAgent.includes('Edge');
